
import React from 'react';
import { cn } from '@/lib/utils';

interface VideoBackgroundProps {
  className?: string;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({ className }) => {
  return (
    <div className={cn('relative w-full h-full overflow-hidden', className)}>
      {/* Solid color background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-purple-light/80 to-purple-DEFAULT/40 z-0"></div>
      
      {/* Optional pattern overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNCI+PHBhdGggZD0iTTM2IDM0djZoNnYtNmgtNnptNiA2djZoNnYtNmgtNnptLTEyIDBoNnY2aC02di02em0xMiAwaDZ2Nmg2djZoLTZ2LTZoLTZ2LTZ6bS02IDEydi02aDZ2Nmg2djZoLTZ2LTZoLTZ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-50 z-1"></div>
    </div>
  );
};

export default VideoBackground;
